import {SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

import {FINANCING_COST_OVERRIDES} from '../constants/FINANCING_COST_OVERRIDES';
import {isValidMoneyAmount} from './isValidMoneyAmount';

type FinancingCostAmountKey = (typeof FINANCING_COST_OVERRIDES)[number]['amountOverrideKey'];

type FinancingMoneyKey =
  | FinancingCostAmountKey
  | 'processingFeeOverride'
  | 'liabilityInsuranceMonthly'
  | 'liabilityInsuranceDeductible'
  | 'comprehensiveInsuranceMonthly'
  | 'comprehensiveInsuranceDeductible';

/** Every money amount the overrides panel lets the user type into a financing body. */
const FINANCING_MONEY_KEYS: FinancingMoneyKey[] = [
  'processingFeeOverride',
  ...FINANCING_COST_OVERRIDES.map((override) => override.amountOverrideKey),
  'liabilityInsuranceMonthly',
  'liabilityInsuranceDeductible',
  'comprehensiveInsuranceMonthly',
  'comprehensiveInsuranceDeductible',
];

/**
 * The first money override the endpoint would reject, or `undefined` when the body may be sent.
 * The inputs show the message but still publish the value, and the offending field can sit in a
 * collapsed card of the financing type that is not even on screen — so the save gate has to find
 * it, rather than letting the request fail and abandon the other type's body with it.
 */
export function findInvalidFinancingMoneyKey(body: SaveSaleVehicleFinancingBody) {
  return FINANCING_MONEY_KEYS.find((key) => !isValidMoneyAmount(body[key]));
}
